import keycloak from '@/application/engine/KeycloakService'
import axios from 'axios'
import {actionTypes} from '@/core/constants'
import store from '@/core/store'

class KeycloakListener {
    async execute() {
        try {
            this.createAdapter()
            this.isPublicRoute()
            await this.startConnection()
            this.setCredentials()
            this.setRefreshToken()
            await this.setDadosUsuario()
        } catch (error) {
            throw new Error('Erro ao iniciar KeycloakAdapter' + error)
        }
    }

    createAdapter() {
        this.keycloakAdapter = keycloak
    }

    isPublicRoute() {
        this.ehRotaPublica = window.location.hash.includes('/public')
    }

    async startConnection() {
        const authenticated = await this.keycloakAdapter.init({
            onLoad: this.ehRotaPublica ? 'check-sso' : 'login-required',
            checkLoginIframe: false,
            pkceMethod: 'S256',
            silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
        })

        if (authenticated && window.location.hash.includes('iss=')) {
            const cleanHash = window.location.hash.split('&')[0]
            window.location.hash = cleanHash
        }
    }

    setCredentials() {
        axios.interceptors.request.use(config => {

            // Se a requisição indicar que deve ignorar autenticação
            if (config.headers && config.headers.skipAuth) {
                delete config.headers.skipAuth
                return config
            }

            // Adiciona o token apenas se existir
            if (this.keycloakAdapter && this.keycloakAdapter.token) {
                config.headers.Authorization = 'Bearer ' + this.keycloakAdapter.token
            }

            return config
        })
    }

    setRefreshToken() {

        setInterval(() => {
            this.keycloakAdapter.updateToken(60)
                .then(refreshed => {
                    if (refreshed) {
                        console.log('Token renovado')
                        this.setCredentials()
                    }
                })
                .catch(() => {
                    this.keycloakAdapter.logout()
                })
        }, 60000)

    }

    async setDadosUsuario() {
        if (this.ehRotaPublica) return
        await store.dispatch(actionTypes.COMUM.BUSCAR_DADOS_USUARIO_AUTENTICADO)
    }
}

export default new KeycloakListener()
